// pages/SuccessPayment.jsx
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SuccessPayment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // دریافت پارامترهای Query String
  const queryParams = new URLSearchParams(location.search);
  const refId = queryParams.get('ref_id') || 'TRX-' + Math.random().toString(36).substring(2, 10).toUpperCase();
  const packageId = queryParams.get('package_id');
  
  // اطلاعات پرداخت (از state یا پارامترها)
  const paymentData = location.state || {
    transactionId: refId,
    amount: queryParams.get('amount') || '۱,۲۰۰,۰۰۰',
    courseName: queryParams.get('course') || 'دوره آموزش React',
    date: new Date().toLocaleDateString('fa-IR')
  };

  useEffect(() => {
    // برای تست روی لوکال‌هاست، این بخش را موقتاً غیرفعال کنید
    // const token = localStorage.getItem('accessToken');
    // if (!token) {
    //   navigate('/login', { replace: true });
    // }
    
    console.log('🟢 Payment Success Page Loaded');
    console.log('Ref ID:', refId);
    console.log('Package ID:', packageId);
    console.log('Payment Data:', paymentData);
    console.log('Full URL:', window.location.href);
  }, [refId, packageId, paymentData]);

  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f0fdf4',
      padding: '20px',
      margin: 0,
    
    },
    card: {
      maxWidth: '500px',
      width: '100%',
      backgroundColor: 'white',
      padding: '40px',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
      textAlign: 'center'
    },
    iconWrapper: {
      width: '80px',
      height: '80px',
      borderRadius: '50%',
      backgroundColor: '#d1fae5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 20px'
    },
    icon: {
      fontSize: '40px',
      color: '#10b981'
    },
    title: {
      color: '#10b981',
      marginBottom: '15px',
      fontSize: '28px'
    },
    subtitle: {
      color: '#6c757d',
      marginBottom: '25px',
      fontSize: '16px'
    },
    infoBox: {
      backgroundColor: '#d1fae5',
      border: '1px solid #a7f3d0',
      color: '#065f46',
      padding: '15px',
      borderRadius: '6px',
      marginBottom: '20px',
      textAlign: 'center',
      fontSize: '14px',
      lineHeight: '1.8'
    },
    infoText: {
      color: '#6c757d',
      fontSize: '13px',
      marginBottom: '8px'
    },
    buttonGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      marginTop: '20px'
    },
    primaryButton: {
      backgroundColor: '#10b981',
      color: 'white',
      border: 'none',
      padding: '12px 20px',
      borderRadius: '6px',
      fontSize: '16px',
      cursor: 'pointer',
      transition: 'background-color 0.2s',
      width: '100%'
    },
    outlineButton: {
      backgroundColor: 'transparent',
      color: '#10b981',
      border: '1px solid #10b981',
      padding: '12px 20px',
      borderRadius: '6px',
      fontSize: '16px',
      cursor: 'pointer',
      transition: 'all 0.2s',
      width: '100%'
    },
    secondaryButton: {
      backgroundColor: 'transparent',
      color: '#6c757d',
      border: '1px solid #6c757d',
      padding: '12px 20px',
      borderRadius: '6px',
      fontSize: '16px',
      cursor: 'pointer',
      transition: 'all 0.2s',
      width: '100%'
    },
    footer: {
      marginTop: '25px',
      paddingTop: '20px',
      borderTop: '1px solid #e9ecef',
      color: '#6c757d',
      fontSize: '12px'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.iconWrapper}>
          <span style={styles.icon}>✅</span>
        </div>
        
        <h2 style={styles.title}>پرداخت موفق</h2>
        <p style={styles.subtitle}>پرداخت شما با موفقیت انجام شد.</p>
        
        <div style={styles.infoBox}>
          <div><strong>شماره تراکنش:</strong> {paymentData.transactionId}</div>
          <div><strong>مبلغ:</strong> {paymentData.amount} تومان</div>
          <div><strong>دوره:</strong> {paymentData.courseName}</div>
          <div><strong>تاریخ:</strong> {paymentData.date}</div>
          {packageId && <div><strong>شناسه بسته:</strong> {packageId}</div>}
        </div>
        
       
        <p style={styles.infoText}>
          می‌توانید از بخش "دوره‌های من" به محتوای دوره دسترسی داشته باشید.
        </p>
        
        <div style={styles.buttonGroup}>
          <button 
            style={styles.primaryButton}
            onClick={() => navigate('/course')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#059669'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#10b981'}
          >
             مشاهده دوره‌های من
          </button>
          
        
          
          <button 
            style={styles.secondaryButton}
            onClick={() => navigate('/')}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#6c757d';
              e.target.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#6c757d';
            }}
          >
            🏠 صفحه اصلی
          </button>
        </div>
        
        <div style={styles.footer}>
          در صورت مشاهده هرگونه مشکل، با پشتیبانی تماس بگیرید.
        </div>
      </div>
    </div>
  );
};

export default SuccessPayment;